export enum DateFormat {
	DEFAULT = '',
	UK = 'uk',
	US = 'us'
}